import React from "react";
import BaseFormPage from "../../base/BaseFormPage";
import ContactPresenter from "../ContactPresenter";

class ContactInquiries extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new ContactPresenter(this);
    this.sectionRef = React.createRef();
    this.observer = null;

    this.state = {
      ...this.state,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        companyName: "",
        industryType: "",
        subject: this.presenter.getProductOptions()[0] || "",
        message: "",
      },
      sectionVisible: false,
    };
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  initObserver = () => {
    if (!this.sectionRef.current) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ sectionVisible: true });
          if (this.observer) this.observer.disconnect();
        }
      },
      { threshold: 0.8 }
    );

    this.observer.observe(this.sectionRef.current);
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.presenter.onChange(value, name);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.presenter.submit(this.state.formData);
  };

  render() {
    const { formData, sectionVisible } = this.state;
    const productOptions = this.presenter.getProductOptions();

    return (
      <section className="contact-inquiries-section py-5" ref={this.sectionRef}>
        <div className="container">
          <div
            className={`card shadow border-0 rounded-4 overflow-hidden slide-in-left ${
              sectionVisible ? "visible" : ""
            }`}
          >
            <div className="row g-0">
              {/* Left: Image */}
              <div className="col-md-6">
                <img
                  src="/assets/images/contactbg2.png"
                  alt="Contact Us"
                  className="img-fluid h-100 w-100 object-fit-cover"
                  style={{ objectFit: "cover", height: "100%" }}
                />
              </div>

              {/* Right: Form */}
              <div className="col-md-6 p-4">
                <form onSubmit={this.handleSubmit}>
                  <h2 className="text-center fw-bold mb-4 text-dark">
                    Send Us a Message
                  </h2>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label fw-semibold">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Juan"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName" className="form-label fw-semibold">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Dela Cruz"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label fw-semibold">
                        Business Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="example@company.com"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="contactNumber" className="form-label fw-semibold">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="09123456789"
                        id="contactNumber"
                        name="contactNumber"
                        maxLength="12"
                        inputMode="numeric"
                        value={formData.contactNumber}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="companyName" className="form-label fw-semibold">
                        Company Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ABC Corporation"
                        id="companyName"
                        name="companyName"
                        value={formData.companyName}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="industryType" className="form-label fw-semibold">
                        Industry Type <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g. Healthcare, Retail"
                        id="industryType"
                        name="industryType"
                        value={formData.industryType}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="subject" className="form-label fw-semibold">
                      Please select a product to inquire: <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="" disabled>Select a product</option>
                      {productOptions.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="message" className="form-label fw-semibold">
                      Message <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Type your message here..."
                      id="message"
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={this.handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="mb-2">
                    <button
                      type="submit"
                      className="btn w-100"
                      style={{
                        backgroundColor: "#020248",
                        color: "#ffffff",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        fontSize: "15px",
                        fontWeight: "600",
                        border: "none",
                      }}
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactInquiries;
